<template>
    <div class="office_banner">
        <swiper ref="swiper" :options="options" @slideChangeTransitionEnd="slideChangeTransitionEnd1">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="cover pc" :style="`background-image: url(${item.banner});`"></div>
                    <div class="cover mobile" :style="`background-image: url(${item.web_banner});`"></div>
                </swiper-slide>
            </template>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <div class="menu">
            <div class="container">
                <div class="menu_inner">
                    <div class="item" 
                    v-for="(item, index) in data" :key="index"
                    :class="{active: menuActiveIndex == index}"
                    @click="changeIndex(index)">{{item.city_name}}</div>
                </div>
            </div>
        </div>
        <swiper ref="swiperMenu" class="menu_mobile" :options="menuOptions" @slideChangeTransitionEnd="slideChangeTransitionEnd2">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">{{item.city_name}}</swiper-slide>
            </template>
        </swiper>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    name: "officeBanner",
    props: [ 'data', 'menuActiveIndex' ],
    data() {
        return {
            options: {
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.office_banner .swiper-button-prev',
                    nextEl: '.office_banner .swiper-button-next',
                },
                observer: true,
                observeParents: true,
            },
            menuOptions: {
                slideToClickedSlide: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
            }
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        },
        swiperMenu() {
            return this.$refs.swiperMenu.swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {
        this.swiper.controller.control = this.swiperMenu;
        this.swiperMenu.controller.control = this.swiper;
    },
    destroyed() {},
    watch: {},
    methods: {
        changeIndex(index){
            this.swiper.slideTo(index);
            this.$emit('change', index);
        },
        slideChangeTransitionEnd1(){
            let index = this.swiper.activeIndex;
            this.swiperMenu.slideTo(index);
            this.$emit('change', index);
        },
        slideChangeTransitionEnd2(){
            let index = this.swiperMenu.activeIndex;
            this.swiper.slideTo(index);
            this.$emit('change', index);
        },
    },
};
</script>

<style scoped lang="scss">
.office_banner{
    position: relative;
    .cover{
        width: 100%;
        height: 6.95rem;
        background: no-repeat center/cover;
        &.mobile{
            display: none;
        }
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .24rem;
        height: .3rem;
        top: 50%;
        margin-top: 0;
        transform: translate(0, -50%);
        background: no-repeat 0/100%;
        &::after{
            display: none;
        }
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: .8rem;
        background-image: url('~@/assets/images/icon_arrow_prev.svg');
    }
    .swiper-button-next{
        right: .8rem;
        background-image: url('~@/assets/images/icon_arrow_next.svg');
    }
    .arrow_down{
        position: absolute;
        z-index: 1;
        left: 50%;
        bottom: .4rem;
        width: .4rem;
        height: .5rem;
        transform: translate(-50%, 0) rotate(90deg);
        background: url('~@/assets/images/icon_arrow_next.svg') no-repeat 0/100%;
    }
    .menu{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        .menu_inner{
            display: flex;
            height: .8rem;
            background: rgba($color: #fff, $alpha: .7);
            border-radius: .04rem .04rem 0 0;
            .item{
                width: 1.8rem;
                font-size: .26rem;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: .04rem .04rem 0 0;
                cursor: pointer;
                &:hover,
                &.active{
                    background: #fff;
                }
            }
        }
    }
    .menu_mobile{
        // display: none;
        height: 0;
    }
    @media only screen and (max-width: 1200px) {
        .cover{
            height: 12rem;
            &.pc{
                display: none;
            }
            &.mobile{
                display: block;
            }
        }
        .swiper-button-prev,
        .swiper-button-next{
            width: .64rem;
            height: .82rem;
        }
        .swiper-button-prev{
            left: .35rem;
        }
        .swiper-button-next{
            right: .35rem;
        }
        .menu{
            display: none;
        }
        .menu_mobile{
            // display: block;
            height: auto;
            background: #b3b3b3;
            .swiper-slide{
                width: 5.6rem;
                height: 1.5rem;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: .72rem;
                border-radius: .04rem .04rem 0 0;
                transition: background-color .5s;
                &.swiper-slide-active{
                    color: #ff4d36;
                    font-weight: bold;
                    background: #fff;
                }
            }
        }
    }
}
</style>